
// object-fit fallback for IE 11
const ua = navigator.userAgent;
const isIE10 = ua.match(/MSIE 10.0/i);
const isIE11 = ua.match(/rv:11.0/i);

if(isIE10 || isIE11) {
	// instead of the object-fit image we just set the src as background
	Array.from(document.querySelectorAll('.codeq-hero-image')).forEach(function(wrapper) {
		const img = wrapper.querySelector('.codeq-hero-image__image');
		const imgSrc = img.getAttribute('src');
		if(!imgSrc) {
			return;
		}
		img.parentNode.removeChild(img);
		wrapper.setAttribute('style', 'background-image: url(' + imgSrc + '); background-size: 100%; padding-top: 40%;');
	});
}
